import { LanguagePreference } from 'models/LanguagePreference'
import $ from 'jquery'

export const callPrivacySetting = (language: LanguagePreference): void => {
  // @ts-ignore
  window.jQuery = $ // needed for the blast modal to close or confirm without breaking
  const utag = (window as any).utag
  if (
    // eslint-disable-next-line
    typeof (window as any).utag?.gdpr?.showConsentPreferences === 'function' &&
    utag?.gdpr?.showConsentPreferences(language)
  ) {
    utag.gdpr.showConsentPreferences()
  }
  // if (onClickLinkAnalytics) {
  //   onClickLinkAnalytics(privacySettingLabel)
  // }
}
